/* Body & Bra — header behavior. External file so it survives section re-renders
   (theme editor / market preview replace section HTML via innerHTML, where inline
   scripts never execute). Document-level delegation + re-init observer. */
(function () {
  'use strict';

  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.error('bb-header:', e); } }

  function headerRoot() {
    return document.querySelector('.bb-hdr-wrap') ? document.querySelector('.bb-hdr-wrap').closest('[id^="bb-hdr-"]') || document.querySelector('[id^="bb-hdr-"]') : document.querySelector('[id^="bb-hdr-"]');
  }

  /* ---------- Flags ---------- */
  function applyFlags() {
    document.querySelectorAll('[data-hdr-flag]').forEach(function (el) {
      var cc = (el.getAttribute('data-hdr-flag') || '').toUpperCase();
      if (cc.length !== 2) return;
      var f = String.fromCodePoint(127397 + cc.charCodeAt(0)) + String.fromCodePoint(127397 + cc.charCodeAt(1));
      if (el.textContent !== f) el.textContent = f;
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-hdr-cd]').forEach(function (cd) {
      if (cd.dataset.bbCdInit) return;
      cd.dataset.bbCdInit = '1';
      var dateAttr = cd.getAttribute('data-hdr-cd') || '';
      var daily = cd.getAttribute('data-hdr-cd-daily') === 'true' || dateAttr === '';
      function nextMidnight() { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); }
      var end = daily ? nextMidnight() : new Date(dateAttr.replace(' ', 'T')).getTime();
      if (isNaN(end)) { daily = true; end = nextMidnight(); }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        if (!document.contains(cd)) return; // section was re-rendered; observer re-inits the new node
        var diff = end - Date.now();
        if (diff <= 0) { if (daily) { end = nextMidnight(); diff = end - Date.now(); } else { diff = 0; } }
        var h = Math.floor(diff / 36e5), m = Math.floor(diff % 36e5 / 6e4), s = Math.floor(diff % 6e4 / 1e3);
        var eh = cd.querySelector('[data-h]'), em = cd.querySelector('[data-m]'), es = cd.querySelector('[data-s]');
        if (eh) eh.textContent = pad(h); if (em) em.textContent = pad(m); if (es) es.textContent = pad(s);
        setTimeout(tick, 1000);
      }
      tick();
    });
  }

  /* ---------- Fade rotators (top bar, trust line, hero social-proof toasts) ----------
     Feedback V7 (homepage 1, second round): the previous fix still let two
     messages paint together on some phones, because it relied on the outgoing
     CSS fade finishing inside a fixed timeout. The rotator no longer
     cross-fades items at all. The whole group fades out, the message is
     swapped while the group is fully transparent, and the group fades back in.
     Inactive items are always visibility hidden with no transition, so only
     one message can ever be painted, on every device and at any frame rate.
     The group keeps its size because the items stay stacked in one grid cell.
     A group that is not stacked (the trust line on desktop shows every item
     in a row) is left alone. */
  function initRotators() {
    document.querySelectorAll('[data-bb-rotate]').forEach(function (group) {
      if (group.dataset.bbRotateInit) return;
      var items = Array.prototype.slice.call(group.children);
      group.dataset.bbRotateInit = '1';
      items.forEach(function (el, idx) { el.classList.toggle('is-active', idx === 0); el.classList.remove('is-leaving'); });
      group.setAttribute('data-bb-rotate-ready', '');
      if (items.length < 2) return;
      var i = 0;
      var interval = parseInt(group.getAttribute('data-bb-rotate-interval'), 10) || 4000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function stacked() { return window.getComputedStyle(group).display === 'grid'; }
      function afterFade(done) {
        if (reduce) { done(); return; }
        var finished = false;
        function finish(e) {
          if (e && (e.target !== group || e.propertyName !== 'opacity')) return;
          if (finished) return;
          finished = true;
          group.removeEventListener('transitionend', finish);
          done();
        }
        group.addEventListener('transitionend', finish);
        setTimeout(finish, 450);
      }
      function step() {
        if (!document.contains(group)) return;
        if (document.hidden || !stacked()) { setTimeout(step, interval); return; }
        group.classList.add('is-fading');
        afterFade(function () {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { group.classList.remove('is-fading'); });
          });
          setTimeout(step, interval);
        });
      }
      setTimeout(step, interval);
    });
  }

  /* ---------- Sticky shadow + optional topbar-hide (positioning is CSS
     position:sticky on the section wrapper; JS only adds a shadow when pinned
     and, when the announcement bar should scroll away, offsets the pin) ---------- */
  function initSticky() {
    document.querySelectorAll('[data-bb-sticky]').forEach(function (wrap) {
      var sec = wrap.parentElement; /* #shopify-section-... (body-level, tall) */
      if (!sec || sec.dataset.bbStickyInit) return;
      sec.dataset.bbStickyInit = '1';
      if (wrap.hasAttribute('data-bb-trust-loose')) {
        var trust = wrap.querySelector('[data-bb-trust]');
        if (trust && sec.nextSibling !== trust) {
          sec.parentNode.insertBefore(trust, sec.nextSibling);
        }
      }
      if (wrap.hasAttribute('data-bb-hidebar')) {
        var measure = function () {
          var bar = wrap.querySelector('.bb-topbar');
          sec.style.setProperty('--bb-stick-top', (bar ? -bar.offsetHeight : 0) + 'px');
        };
        measure();
        window.addEventListener('resize', measure);
      }
      var sentinel = document.createElement('div');
      sentinel.className = 'bb-hdr__sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'width:100%;height:1px;margin-bottom:-1px;pointer-events:none;';
      var prev = sec.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('bb-hdr__sentinel')) prev.remove();
      sec.parentNode.insertBefore(sentinel, sec);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        sec.classList.toggle('is-stuck', !entries[0].isIntersecting);
      }, { threshold: 0 });
      io.observe(sentinel);
    });
  }

  /* ---------- Delegated interactions (survive any re-render) ---------- */
  document.addEventListener('click', function (e) {
    var r = headerRoot();

    if (e.target.closest('[data-hdr-open]')) {
      safe(function () {
        if (!r) return;
        var drawer = r.querySelector('[data-hdr-drawer]');
        var scrim = r.querySelector('[data-hdr-scrim]');
        if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
        if (scrim) { scrim.hidden = false; }
        document.body.style.overflow = 'hidden';
      });
      return;
    }
    if (e.target.closest('[data-hdr-close]') || e.target.closest('[data-hdr-scrim]')) {
      safe(function () {
        if (!r) return;
        var drawer = r.querySelector('[data-hdr-drawer]');
        var scrim = r.querySelector('[data-hdr-scrim]');
        if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
        if (scrim) { scrim.hidden = true; }
        document.body.style.overflow = '';
      });
      return;
    }
    var toggle = e.target.closest('[data-loc-toggle]');
    if (toggle) {
      safe(function () {
        var menu = toggle.parentNode.querySelector('[data-loc-menu]');
        if (!menu) return;
        var willOpen = menu.hidden;
        menu.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
      });
      return;
    }
    var opt = e.target.closest('[data-loc-value]');
    if (opt) {
      safe(function () {
        /* Feedback V7 (homepage 2): on mobile the drawer's selector reloaded
           the page but kept the old country. The choice is now posted through
           a fresh form on <body>, built from the Liquid form's own hidden
           fields, so nothing around the drawer (other forms, overlays, scroll
           lock) can swallow or redirect the submit. return_to keeps the
           current query string so a preview session stays on this theme. */
        var src = opt.closest('form');
        var code = opt.getAttribute('data-loc-value');
        if (!code) return;
        var f = document.createElement('form');
        f.method = 'post';
        f.action = (src && src.getAttribute('action')) || '/localization';
        f.acceptCharset = 'UTF-8';
        f.style.display = 'none';
        var seen = {};
        function add(name, value) {
          var i = document.createElement('input');
          i.type = 'hidden'; i.name = name; i.value = value;
          f.appendChild(i); seen[name] = true;
        }
        if (src) {
          src.querySelectorAll('input[type="hidden"]').forEach(function (h) {
            if (!h.name || h.name === 'country_code' || h.name === 'return_to') return;
            add(h.name, h.value);
          });
        }
        if (!seen.form_type) add('form_type', 'localization');
        if (!seen.utf8) add('utf8', '\u2713');
        if (!seen._method) add('_method', 'put');
        var q = (window.location.search || '').replace(/([?&])(country|currency)=[^&]*&?/gi, '$1').replace(/[?&]$/, '');
        add('return_to', window.location.pathname + q);
        add('country_code', code);
        document.body.appendChild(f);
        document.body.style.overflow = '';
        HTMLFormElement.prototype.submit.call(f);
      });
      return;
    }
    // outside click closes any open market menu
    safe(function () {
      document.querySelectorAll('[data-loc-menu]').forEach(function (menu) {
        if (menu.hidden) return;
        var btn = menu.parentNode.querySelector('[data-loc-toggle]');
        if (!menu.contains(e.target) && (!btn || !btn.contains(e.target))) {
          menu.hidden = true;
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  });

  /* ---------- Init + re-init on section re-render ---------- */
  function initAll() { safe(applyFlags); safe(initCountdowns); safe(initRotators); safe(initSticky); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () { scheduled = false; initAll(); }, 100);
  });
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }

  document.addEventListener('shopify:section:load', initAll);
})();
